import React from 'react'
import { GeckoSiteObservation } from 'types'

interface ObservationDialoguePositionFormProps {
  coordinates: GeckoSiteObservation['data']['pointCloudCoordinates']
  setFormData: React.Dispatch<
    React.SetStateAction<Partial<GeckoSiteObservation['data']>>
  >
  disabled: boolean
  labelStyle: React.CSSProperties
  inputBaseStyle: React.CSSProperties
  rowStyle: React.CSSProperties
}

export const ObservationDialoguePositionForm: React.FC<
  ObservationDialoguePositionFormProps
> = ({
  coordinates,
  setFormData,
  disabled,
  labelStyle,
  inputBaseStyle,
  rowStyle,
}) => {
  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    axis: 'x' | 'y' | 'z'
  ) => {
    const value = parseFloat(e.target.value)
    if (!isNaN(value)) {
      setFormData((prev) => {
        const currentCoords = prev.pointCloudCoordinates?.coordinate ?? [
          0, 0, 0,
        ]
        let newCoords: [number, number, number]
        switch (axis) {
          case 'x':
            newCoords = [value, currentCoords[1], currentCoords[2]]
            break
          case 'y':
            newCoords = [currentCoords[0], value, currentCoords[2]]
            break
          case 'z':
            newCoords = [currentCoords[0], currentCoords[1], value]
            break
        }
        return {
          ...prev,
          pointCloudCoordinates: {
            ...prev.pointCloudCoordinates,
            coordinate: newCoords,
          },
        }
      })
    }
  }

  return (
    <div style={{ ...rowStyle, marginBottom: '8px' }}>
      <label style={labelStyle}>Position (XYZ)</label>
      <div style={{ display: 'flex', gap: '5px' }}>
        <input
          type='number'
          step='0.01'
          style={{
            ...inputBaseStyle,
            width: '70px',
            flex: '0 0 auto',
            fontFamily: 'monospace',
          }}
          value={coordinates?.coordinate?.[0] ?? ''}
          onChange={(e) => handleInputChange(e, 'x')}
          placeholder='X'
          disabled={disabled}
          onMouseDown={(e) => e.stopPropagation()}
        />
        <input
          type='number'
          step='0.01'
          style={{
            ...inputBaseStyle,
            width: '70px',
            flex: '0 0 auto',
            fontFamily: 'monospace',
          }}
          value={coordinates?.coordinate?.[1] ?? ''}
          onChange={(e) => handleInputChange(e, 'y')}
          placeholder='Y'
          disabled={disabled}
          onMouseDown={(e) => e.stopPropagation()}
        />
        <input
          type='number'
          step='0.01'
          style={{
            ...inputBaseStyle,
            width: '70px',
            flex: '0 0 auto',
            fontFamily: 'monospace',
          }}
          value={coordinates?.coordinate?.[2] ?? ''}
          onChange={(e) => handleInputChange(e, 'z')}
          placeholder='Z'
          disabled={disabled}
          onMouseDown={(e) => e.stopPropagation()}
        />
      </div>
    </div>
  )
}
